module.exports = __webpack_public_path__ + "img/gown.ddd1c9e7.png";